import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root: 'mb-4 grid grid-cols-2 gap-[0.6rem] transition-opacity duration-200 md:grid-cols-3'
    },
    variants: {
        disabled: {
            true: { root: 'pointer-events-none opacity-55' },
            false: { root: 'opacity-100' }
        }
    }
} satisfies ComponentTheme;
